import { render, staticRenderFns } from "./ClientInput.vue?vue&type=template&id=9f1044c8&"
import script from "./ClientInput.vue?vue&type=script&lang=js&"
export * from "./ClientInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports